import React from 'react';
import { Row, Col } from 'reactstrap';

export class Variant extends React.Component {

  render(){
    let content;
    let contentSmall;

    let product_code = null;
    let intensity = null;
    let icao_type = null;
    let faa_type = null;
    let color = null;
    let voltage = null;
    let lighting = null;
    let option = null;

    if(!this.props.acf)
      return null;

    if(this.props.header){
      content = (
        <Row className={ this.props.itemStyle }>
          <Col xs="8" lg="3">Product Code</Col>
          <Col xs="4" lg="2">Output</Col>
          <Col xs="12" lg="7" className={"d-xs-none d-lg-flex"}>Standard & features</Col>
        </Row>
      );
    } else {

      product_code =  this.props.post_title || this.props.acf.obx_product_code;

      try {
        intensity = Math.max
          .apply(null,this.props.acf.obx_product_intensities
            .map(o => {
              switch(typeof o.obx_product_intensity){
                case 'number':
                  return o.obx_product_intensity;
                case 'string':
                  return o.obx_product_intensity.replace(/( cd|cd)/,'');
                default:
                  return 0;
              }
            })
          ) + '\u00A0cd';
      } catch(e){

      }


      if (!(typeof this.props.acf.obx_product_icao_types === 'boolean')) {
        icao_type = this.props.acf.obx_product_icao_types.map((o,i) =>
          <span className="variant-tag" key={i} color="primary">{o.obx_product_icao_type}</span>
        )
      }


      if (!(typeof this.props.acf.obx_product_faa_types === 'boolean')) {
        faa_type = this.props.acf.obx_product_faa_types.map((o,i) =>
          <span className="variant-tag" key={i} color="primary">{o.obx_product_faa_type}</span>
        )
      }


      if (!(typeof this.props.acf.obx_product_colors === 'boolean')) {
        color = this.props.acf.obx_product_colors.map((o,i) =>
          <span className="variant-tag" key={i} color="primary">{o.obx_product_color}</span>
        )
      }


      if (!(typeof this.props.acf.obx_product_voltages === 'boolean')) {
        voltage = this.props.acf.obx_product_voltages.map((o,i) =>
          <span className="variant-tag" key={i} color="primary">{o.obx_product_voltage}</span>
        )
      }


      if (!(typeof this.props.acf.obx_product_lightings === 'boolean')) {
        lighting = this.props.acf.obx_product_lightings.map((o,i) =>
          <span className="variant-tag" key={i} color="primary">{o.obx_product_lighting}</span>
        )
      }

      if (!(typeof this.props.acf.obx_product_options === 'boolean')) {
        option = this.props.acf.obx_product_options.map((o,i) =>
          <span className="variant-tag" key={i} color="primary">{o.obx_product_option}</span>
        )
      }


      content = (
        <Row className={ this.props.itemStyle + " variant-row" }>
          <Col xs="12" lg="2" className="product-code tag-container">{ product_code }</Col>
          <Col xs="6" lg="1" className={"tag-container"}>{ intensity }</Col>
          <Col xs="6" lg="1" className={"tag-container"}>{ icao_type }</Col>
          <Col xs="6" lg="1" className={"tag-container"}>{ faa_type }</Col>
          <Col xs="6" lg="2" className={"tag-container"}>{ voltage }</Col>
          <Col xs="6" lg="1" className={"tag-container"}>{ color }</Col>
          <Col xs="6" lg="1" className={"tag-container"}>{ lighting }</Col>
          <Col xs="6" lg="3" className={"tag-container"}>{ option }</Col>
        </Row>
      );

      contentSmall = (
        <Row className={ this.props.itemStyle + " variant-row" }>
          <Col xs="12" className="product-code tag-container">{ product_code }</Col>
          {
            Boolean(intensity) &&
              <Col xs="12" className={"tag-container"}><span className={"tag-row-header"}>Intensity</span><span> { intensity }</span></Col>
          }
          {
            (Boolean(icao_type) || Boolean(faa_type)) &&
              <Col xs="12" className={"tag-container"}><span className={"tag-row-header"}>ICAO & FAA</span><span> {icao_type} {faa_type}</span></Col>
          }
          {
            Boolean(voltage) &&
              <Col xs="12" className={"tag-container"}><span className={"tag-row-header"}>Voltage</span><span> { voltage }</span></Col>
          }
          {
            (Boolean(color) || Boolean(lighting)) &&
            <Col xs="12" className={"tag-container"}><span className={"tag-row-header"}>Light</span>
              <span> {color} {lighting}</span></Col>
          }
          {
            Boolean(option) &&
            <Col xs="12" className={"tag-container"}><span className={"tag-row-header"}>Options</span>
              <span> {option}</span></Col>
          }
        </Row>
          );
    }

    return <div><div className="d-none d-lg-block">{ content }</div><div className="d-lg-none">{ contentSmall }</div></div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/item/Variant.js